import { useState } from 'react';
import { ImageIcon } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

const ArticleImage = ({ src, alt, className = '', containerClassName = '' }) => {
  const [hasError, setHasError] = useState(false);

  // Resolve image URL: prefix /api paths with backend URL
  const resolvedSrc = src?.startsWith('/api') ? `${API}${src}` : src;

  if (!src || hasError) {
    return (
      <div className={`bg-gradient-to-br from-blue-50 to-slate-100 flex items-center justify-center ${containerClassName}`}>
        <ImageIcon className="w-12 h-12 text-slate-300" />
      </div>
    );
  }

  return (
    <img
      src={resolvedSrc}
      alt={alt || ''}
      className={className}
      onError={() => setHasError(true)}
      loading="lazy"
    />
  );
};

export default ArticleImage;
